<template>
  <v-row dense>
    <v-col>
      <navigation-drawer
        color="white"
        :depth="1"
        permanent
        clipped
        fixed
        class="pt-8"
        :width="250"
      >
        <v-list dense class="mb-10">
          <v-list-item dense v-for="(examGroup, key) in examGroups" :key="key">
            <v-list-item-content>
              <v-list-item-title>
                <v-row dense>
                  <v-col class="text-body-1 gray--text text--lighten-1 font-weight-bold">
                    <v-tooltip top max-width="450">
                      <template v-slot:activator="{ on, attrs }">
                        <span :attrs="attrs" v-on="on">
                          {{ key | truncate(24) }}
                        </span>
                      </template>

                      <span>
                        {{ key }}
                      </span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="auto">
                    <v-btn icon small @click="toggleShowExamGroupKey(key, examGroup)">
                      <v-icon v-if="showExamGroupKey === key">eva-chevron-up-outline</v-icon>
                      <v-icon v-else>eva-chevron-down-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-title>

              <v-timeline dense v-show="showExamGroupKey === key">
                <v-timeline-item
                  v-for="item in examGroup"
                  :key="item.id"
                  :color="item.id === examId ? 'primary' : 'gray lighten-1'"
                  small
                >
                  <v-row dense>
                    <v-col>
                      <v-btn text block small @click="selectExam(item.id)">
                        {{
                          $moment(item.executedAt, "YYYY-MM-DD HH:mm:ss ZZ")
                            | moment("DD MMMM Y")
                        }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </navigation-drawer>

      <v-row style="padding-left: 250px">
        <v-col>
         <v-row dense align="center"> 
             <v-col cols="auto" class="text-h3 gray--text">Exames</v-col>

             <v-col cols="auto" class="ps-6"> 
             <authorization
              can="print"
              v-slot:default="{ authorization }">                                                                                                        
            <v-btn small icon :disabled="false" :loading="printLoading" @click="downloadArchive" v-if="authorization || forcePrint">
              <v-icon>eva-printer-outline</v-icon>                                                                  
            </v-btn>
            </authorization>
        </v-col>

            <!-- <v-col cols="auto"> -->
            <!--   <EsignButton :esign="exam.lastEsign" v-if="exam" /> -->
            <!-- </v-col> -->
          </v-row>

          <v-row v-if="lodash.isEmpty(exam)" justify="center">
            <v-col cols="6">
              <v-alert color="orange" outlined text type="info">
                Sem exames
              </v-alert>
            </v-col>
          </v-row>

          <v-row v-else>
            <ExamForm  :exam="exam" :attendanceEsigned="true" :key="examId" v-if="exam" disabled />
              <FormLargeSkeletonLoader v-else :rows="7" />
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import ExamForm from "@/components/exam/form.vue";
  import FormLargeSkeletonLoader from "@/components/ui/form/large_skeleton_loader.vue";

  export default {
    props: {
      patient: Object,
    },
    components: {
      ExamForm,
      FormLargeSkeletonLoader,
    },

    data() {
      return {
        examId: null,
        showExamGroupKey: false,
        printLoading: false,
      };
    },

    mounted() {
      let exam = this.lodash.first(this.exams);

      if (exam) {
        this.examId = exam.id;
        this.showExamGroupKey = exam.examTemplate.name;
      }
    },
    apollo: {
      exam: {
        query: require("@/graphql/exam/exam.gql"),
        fetchPolicy: 'no-cache',
        variables() {
          return {
            examId: this.examId,
          };
        },
        skip() {
          return this.lodash.isEmpty(this.examId);
        },
      },
    },
    computed: {
      exams() {
        return this.lodash.orderBy(
          this.patient.exams,
          [
            function(o) {
              return this.$moment(o.executedAt, "YYYY-MM-DD HH:mm:ss ZZ");
            }.bind(this),
          ],
          ["desc"]
        );
      },
      examGroups() {
        const unordered = this.lodash.groupBy(this.exams, "examTemplate.name");
        const ordered = {};
        Object.keys(unordered)
          .sort()
          .forEach(function(key) {
            ordered[key] = unordered[key];
          });
        return ordered;
      },
    },
    methods: {
      toggleShowExamGroupKey(key, examGroup) {
        if (this.showExamGroupKey === key) {
          this.showExamGroupKey = "";
        } else {
          this.showExamGroupKey = key;
          this.selectExam(this.lodash.first(examGroup).id);
        }
      },

      selectExam(examId) {
        if (examId === this.examId) return
        this.exam = null;
        this.examId = examId;
      },
      
      async refreshList() {
        await this.$apollo.queries.exam.refetch();
      },

      async generatePreview() {
        await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),

        variables: {
          esignId: this.exam.lastEsign.id,
          dynamicForm: true,
          examAppraisal: true 
        },
      });
      },

    async downloadArchive() {
      this.printLoading = true;

      await this.generatePreview();
      await this.refreshList();
      
      //await this.$store.dispatch("authentication/refreshToken");

      await this.refreshList();

      const file_url = this.exam.lastEsign.fileUrl;
      await window.open(`${process.env.VUE_APP_BASE_URL}${file_url}`, "_blank");

      this.printLoading = false;
    },
    },
  };
</script>

<style lang="scss" scoped></style>
